<template>
    <div>
        <div id="SIgoodsEditPage" v-loading="dialogLoading">
            <div class="form-main">
                <el-form status-icon :rules="rules" :model="partData" ref="partData" label-width="100px" class="form-ctn">
                    <div class="form-main">
                        <div class="form=line">
                            <div class="form-item" style="width: 100%" v-if="picturesCount > 0 && disabledForm">
                                <el-form-item label="汽配图片">
                                    <el-image
                                        style="width: 100px; height: 100px; margin-right: 10px"
                                        :key="index"
                                        v-for="(item, index) in reViewList"
                                        :src="item + '?imageView2/2/w/200'"
                                        :z-index="99999"
                                        @click="showGoodsImages(index)"
                                    ></el-image>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="汽配名称" prop="GoodName">
                                    <el-autocomplete
                                        class="search-item"
                                        size="medium"
                                        v-model="partData.GoodName"
                                        :debounce="500"
                                        placeholder="请输入配件名称"
                                        :trigger-on-focus="false"
                                        :disabled="disabledForm"
                                    ></el-autocomplete>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="汽配英文名称" prop="ExAttribute4">
                                    <el-input v-model="partData.ExAttribute4" class="search-item" size="small" :disabled="disabledForm"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="英文车型">
                                    <el-input v-model="partData.ExAttribute6" :disabled="disabledForm" class="search-item" size="medium"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="汽配编码" prop="APCode">
                                    <el-input class="search-item" size="small" v-model="partData.APCode" :disabled="disabledForm"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="产地" width="100px">
                                    <el-autocomplete
                                        size="small"
                                        class="search-item"
                                        v-model="partData.Origin"
                                        :debounce="500"
                                        placeholder="请输入产地"
                                        :trigger-on-focus="false"
                                        :disabled="disabledForm"
                                    ></el-autocomplete>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="单位" prop="Unit">
                                    <el-select
                                        size="small"
                                        v-model="partData.Unit"
                                        filterable
                                        allow-create
                                        placeholder=""
                                        :disabled="disabledForm"
                                    >
                                        <el-option v-for="item in unitList" :key="item.Value" :label="item.Value" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="适用车型" prop="AutoSerise">
                                    <el-popover v-if="disabledForm" placement="top-start" title="适用车型" trigger="hover" :content="partData.AutoSerise">
                                        <el-input slot="reference" v-model="partData.AutoSerise" class="search-item" size="small" :disabled="disabledForm"></el-input>
                                    </el-popover>
                                    <el-autocomplete
                                        class="search-item"
                                        clearable
                                        popper-class="autocomplete"
                                        :debounce="500"
                                        v-model.trim="partData.AutoSerise"
                                        size="small"
                                        :trigger-on-focus="false"
                                        v-else
                                    ></el-autocomplete>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="汽配分类" prop="ExAttribute1">
                                    <el-select
                                        allow-create
                                        size="small"
                                        v-model="partData.ExAttribute1"
                                        filterable
                                        clearable
                                        reserve-keyword
                                        :disabled="disabledForm"
                                    >
                                        <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                            <div class="option-content">
                                                <div>{{ optionItem.Text }}</div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="重量">
                                    <el-input v-model="partData.Quality" class="search-item" size="small" placeholder="" :disabled="disabledForm">
                                        <template slot="append">kg</template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="批发价" prop="Price">
                                    <el-input
                                        type="number"
                                        step="0.01"
                                        v-model="partData.Price"
                                        class="search-item"
                                        size="medium"
                                        :min="0"
                                        :disabled="disabledForm"
                                    >
                                        <template slot="append">¥</template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                            </div>
                            <div class="form-item">
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="配件尺寸" prop="Size">
                                    <el-input v-model="partData.Size" class="search-item" size="small" placeholder="" :disabled="disabledForm"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="材质" prop="Texture">
                                    <el-input v-model="partData.Texture" class="search-item" size="small" placeholder="" :disabled="disabledForm"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="颜色" prop="Color">
                                    <el-input v-model="partData.Color" class="search-item" size="small" placeholder="" :disabled="disabledForm"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-item" style="width: 90%;margin-bottom: 20px;">
                                <el-form-item label="包装尺寸" class="packageSize">
                                    长
                                    <input v-model.number="partData.Length" :disabled="disabledForm" type="number" step="0.01" min="0" size="small" />
                                    &nbsp;宽
                                    <input v-model.number="partData.Width" :disabled="disabledForm" type="number" step="0.01" min="0" size="small" />
                                    &nbsp;高
                                    <input v-model.number="partData.Height" :disabled="disabledForm" type="number" step="0.01" min="0" size="small" />
                                    (cm)
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="imgReviewList" :z-index="99999" />
    </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
    name: '',
    props: {
        EntpTempGoodsId: String
    },
    components: {
        ElImageViewer
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        return {
            title: '配件信息',
            goodsId: this.EntpTempGoodsId,
            disabledForm: true,
            partData: {},
            dialogLoading: false,
            loading: false,
            brandList: [],
            apCategoryList: [],
            unitList: [],
            reViewList: [],
            downloadUrl: this.$util.QN_URL_BASE,
            picturesCount: 0,
            rules: {
                APCode: [{ required: true, message: '该项必填', trigger: 'blur' },],
                APId: [{ required: true, message: '该项必填', trigger: 'change' }],
                ExAttribute1: [{ required: true, message: '该项必填', trigger: 'blur' }],
                GoodName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                EnName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                PictureList: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Price: [
                    { validator: checkPositive, trigger: 'blur' },
                    { required: true, message: '该项必填', trigger: 'blur' }
                ],
                Quality: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                Brand: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Unit: [{ required: true, message: '该项必填', trigger: 'blur' }],
                AutoSerise: [{ required: true, message: '该项必填', trigger: 'blur' }],
            },
            showViewer: false,
            imgReviewList: [],
            isShowAutoSeriseEng: true,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.getEnterprisePart();
    },
    mounted() {},
    methods: {
        showGoodsImages(index) {
            let tempImgList = [...this.reViewList]; //所有图片地址
            if (index == 0) {
                this.imgReviewList = tempImgList;
            } else {
                // 调整图片顺序，把当前图片放在第一位
                let start = tempImgList.splice(index);
                let remain = tempImgList.splice(0, index);
                this.imgReviewList = start.concat(remain);
            }
            this.showViewer = true;
        },
        closeViewer() {
            this.showViewer = false;
        },
        //获取配件信息
        getEnterprisePart() {
            let that = this;
            that.dialogLoading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetPartInVenData',
                        data: {
                            EntpTempGoodsId: that.goodsId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;

                        that.reViewList = [];
                        if (data.MainImg) {
                            that.reViewList.push(that.downloadUrl + data.MainImg);
                            that.picturesCount = 1;
                        }
                        if (data.PictureList) {

                            that.picturesCount += data.PictureList.length;

                            for (let i = 0; i < data.PictureList.length; i++) {
                                that.reViewList.push(that.downloadUrl + data.PictureList[i]);
                            }
                        }
                        if (data.PackageSize) {
                            let packageSize = data.PackageSize.split('*');
                            if (packageSize) {
                                data.Length = packageSize[0];
                                data.Width = packageSize[1];
                                data.Height = packageSize[2];
                            }
                        }
                        let packageSize = data.PackageSize.split('*');
                        if (packageSize) {
                            data.Length = packageSize[0];
                            data.Width = packageSize[1];
                            data.Height = packageSize[2];
                        }
                        if (data.GoodDesc) {
                            let goodDescArr = data.GoodDesc.split('|').map(m => {
                                let i = m.split(':');
                                return {
                                    key: i[0],
                                    value: i[1]
                                };
                            });
                            data.GoodDesc = goodDescArr;
                        } else {
                            data.GoodDesc = [{ key: '', value: '' }];
                        }

                        that.partData = data;
                        resolve();
                    })
                    .finally(() => {
                        that.dialogLoading = false;
                    });
            });
        },
    }
};
</script>
<style lang="less" scoped>
.form-main {
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;

    .el-form-item {
        margin-bottom: 10px;
    }
}

.form-line {
    display: flex;
    flex-direction: row;
}

.form-item {
    width: 350px;

    .el-input {
        width: 200px;
    }

    .el-select {
        width: 200px;
    }
}

.form-item-remark {
    textarea {
        height: 100px;
    }

    .el-textarea {
        height: 100px;
    }

    .el-textarea__inner {
        height: 100px;
    }
}

.table-title {
    .cell-item {
        width: 33.33%;
    }

    .div-table-cell {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
}

.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .cell-line {
        display: flex;
        width: 100%;
    }

    .cell-item {
        padding: 0 10px;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
.calc-btn {
    margin-left: 5px;
}
</style>
<style lang="less">
.el-popover {
    max-width: 500px;
}

//辅助图片出现滚条
.el-upload-list {
    max-height: 120px;
    overflow-y: auto;
}

.packageSize {
    input {
        outline: none;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        border: none;
        border: 1px solid #dcdfe6;
        text-align: center;
        width: 100px;
    }

    input:disabled {
        color: #606266;
        cursor: not-allowed;
        background-color: #f5f7fa;
    }
}

</style>
